import React from 'react'
import { Col, Row } from 'react-bootstrap'
import DiscussionsList from '../discussions-list'
import ParticipationsList from '../participations-list'
import useClientLocation from '../../../hooks/use-client-location'

const DiscussionsScreen = () => {
    const { params } = useClientLocation()
    const { discussionId } = params
    return (
        <Row style={{ height: 'calc(100%)' }}>
            <DiscussionsList/>
            <Col style={{ height: 'calc(100%)', paddingLeft: '0px' }}>
                <ParticipationsList discussionId={discussionId} />
            </Col>
        </Row>
    )
}

export default DiscussionsScreen
